import ImagesWhySpiritoryWhySpiritoryV2Webp from '@/public/images/why-spiritory/why-spiritory-v2.webp';
import ImagesWhySpiritoryWhySpiritoryWebp from '@/public/images/why-spiritory/why_spiritory.webp';

export { ImagesWhySpiritoryWhySpiritoryV2Webp, ImagesWhySpiritoryWhySpiritoryWebp };
